import React from 'react'
import '../graphStyles.scss'

import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    BarController,
    LineController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import NoDataFound from '../../NoDataFound';
ChartJS.register(
    LinearScale,
    CategoryScale,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    BarElement,
    LineController,
    BarController
)

export function EngagedShopperGraph({ engagedShopper, loading }) {

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
        },

        scales: {
            x: {
                display: false
            },
            y: {
                title: {
                    display: true,
                    text: "Coupons shown",
                    font: {
                        size: 13.5
                    }
                },

            },
            y1: {
                position: 'right',
                title: {
                    display: true,
                    text: "Bought buyer %",
                    font: {
                        size: 13.5,
                    }
                },
                min: 0

            }
        }
    }

    const data = {
        labels: engagedShopper.labels,
        datasets: [
            {
                data: engagedShopper.couponsShown,
                type: 'line',
                fill: true,
                backgroundColor: 'rgba(0, 100, 240, 0.25)',
                hoverBackgroundColor: 'rgba(0, 100, 240, 0.25)',
                borderColor: 'rgba(0, 100, 240, 1)',
                lineTension: 0.2,
                order: 1,
            },
            {
                data: engagedShopper.boughtPercentBuyer,
                type: 'line',
                backgroundColor: '#f1612f',
                hoverBackgroundColor: '#f1612f',
                borderColor: '#f1612f',
                lineTension: 0.2,
                yAxisID: 'y1',
                order: 0,
            }
        ]
    }


    return (
        <div className='graph flex flex-col'>
            <div className='graph__title'>
                <h4>Nudge shown to bought conversion</h4>
            </div>
            {
                loading ?
                    <div className="loader flex-grow flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="185px" height="185px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" r="0" fill="none" stroke="#b927d4" strokeWidth="1">
                                <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="0s"></animate>
                                <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="0s"></animate>
                            </circle><circle cx="50" cy="50" r="0" fill="none" stroke="#32c5ff" strokeWidth="1">
                                <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
                                <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
                            </circle>
                        </svg>
                    </div>
                    : (
                        <>
                        {engagedShopper.labels &&
                        engagedShopper.labels.length !== 0 ? (
                            <Chart className='chart' id='chart17' options={options} data={data} />
                          ) : (
                          <NoDataFound />
                        )}
                      </>
                    )
            }
        </div>
    )
}